import {
  getSessionTeamRoles,
  hasPermission,
  isSuperAdminUser,
} from "../utils/auth";
import { ROUTE_PERMISSIONS } from "./routePermissions";

/** Sidebar menu mirrored from the brand business dashboard */
export const DEFAULT_PROJECT_ID = "";

export const businessPath = (projectId, segment) =>
  `/businessprojects/${projectId}/${segment}`;

const requiredPermissionForPath = (path) => {
  if (!path) return null;
  if (Object.prototype.hasOwnProperty.call(ROUTE_PERMISSIONS, path)) {
    return ROUTE_PERMISSIONS[path];
  }
  const match = Object.keys(ROUTE_PERMISSIONS).find(
    (key) => key.toLowerCase() === String(path).toLowerCase(),
  );
  return match ? ROUTE_PERMISSIONS[match] : undefined;
};

/**
 * Sidebar follows team-role flags.
 * Superadmin → Full Access; admin → Admin Access (registration.js).
 */
export const canAccessBusinessPath = (path, projectId) => {
  if (!path) return true;
  if (isSuperAdminUser()) return true;
  const required = requiredPermissionForPath(path);
  if (required === undefined) return false;
  if (required === null) {
    return getSessionTeamRoles().length === 0;
  }
  return hasPermission(required, undefined, projectId);
};

export const getVisibleBusinessMenu = (projectId) =>
  BUSINESS_MENU.map((item) => {
    if (!item.children) {
      return canAccessBusinessPath(item.path, projectId) ? item : null;
    }
    const children = item.children.filter((child) =>
      canAccessBusinessPath(child.path, projectId),
    );
    if (children.length === 0) return null;
    return { ...item, children };
  }).filter(Boolean);

export const BUSINESS_MENU = [
  { id: "dashboard", label: "Dashboard", path: "dashboard" },
  {
    id: "team-inbox",
    label: "Team Inbox",
    children: [
      { label: "LiveChat", path: "livechat" },
      { label: "History", path: "history" },
      { label: "Test Message", path: "sendtestmessage" },
    ],
  },
  {
    id: "contacts",
    label: "Contacts",
    children: [
      { label: "Leads", path: "contacts" },
      { label: "Archived Leads", path: "archivedcontacts" },
    ],
  },
  {
    id: "campaign",
    label: "Campaign",
    children: [
      { label: "Campaign Report", path: "fetchingallcampaign" },
      { label: "Broadcast", path: "broadcastCampaign" },
      { label: "WhatsApp from Excel", path: "campaign" },
      { label: "API Campaign", path: "apicampaign" },
      { label: "WA+SMS Broadcast", path: "whatsapp+sms_campaign" },
    ],
  },
  {
    id: "users",
    label: "Users",
    children: [
      { label: "Agent", path: "allteams" },
      { label: "Teams Roles", path: "teamroles" },
      { label: "My Profile", path: "myprofile" },
      { label: "Change Password", path: "changepassword" },
    ],
  },
  /*{
    id: "settings",
    label: "Settings",
    children: [
      { label: "My Profile", path: "myprofile" },
      { label: "Change Password", path: "changepassword" },
    ],
  },*/
  {
    id: "template",
    label: "Template",
    children: [
      { label: "WhatsApp Template", path: "fetchalltemplates" },
      { label: "SMS Template", path: "allsmstemplate" },
      { label: "Template Library", path: "templatelib" },
    ],
  },
  {
    id: "configuration",
    label: "Configuration",
    children: [
      { label: "Quick Replies", path: "fetchallcannedmessage" },
      { label: "User Attributes", path: "attribute" },
      { label: "Tag", path: "fetchalltags" },
    ],
  },

  {
    id: "automations",
    label: "Automations",
    children: [
      { label: "Greeting Message", path: "livechatsettings" },
      { label: "Opt-in Management", path: "optin-outmanagement" },
      { label: "Flow Builder", path: "whatsappform" },
      { label: "Chatbot AI", path: "chatbotai" },
    ],
  },
 
  {
    id: "application-bar",
    label: "Application Bar",
    children: [
      { label: "Api key", path: "apikeygenerate" },
     /* { label: "WABA Analytics", path: "waba_analytics" },*/
      { label: "Analytics", path: "waba_analytics" },
      { label: "Agent Activity", path: "agentactivity" },
      { label: "Plans", path: "plans" },
    ],
  },
  {
    id: "integration",
    label: "Integration",
    children: [
      { label: "Webhook", path: "webhookSubscribe" },
      /*{ label: "WhatsApp Widget", path: "whatsapp-widget-button" },*/
      { label: "SMS Config", path: "smsconfig" },
      { label: "Google Form", path: "googleformconfig" },
    ],
  },
  /* {
    id: "whatsapp-payments",
    label: "WhatsApp Payments",
    children: [
      { label: "Payments", path: "payments" },
      { label: "Payments Setup", path: "paymentsetup" },
    ],
  },
  {
    id: "ecommerce",
    label: "Ecommerce",
    children: [
      { label: "Woocommerce Store", path: "woocommerce_store" },
      { label: "Shopify Store", path: "shopify_store" },
    ],
  },
  */
];
